/* eslint-disable max-len */
import { dataService } from "../services/data.services";
import { CognitoCurrentData } from "./CognitoData";
import { GetBranchId } from "./GetBranchId";

const convertData=(data)=>{
    const arr=[];
    data?.forEach(element => {
        arr.push({
            name:element.full_name,
            _id:element._id
        })
        
    });
    return arr
}
export const handlefetch = async() => {
    const res=await CognitoCurrentData();
    const id = await GetBranchId()
    const [yearList, classList,sectionList,teachers,subjectList,exams] = await Promise.all([
        dataService.GetAPI(`academic-years?filter=true&branch_id=${id}&status=ongoing,upcoming`),
        dataService.GetAPI(`classes?branch_id=${id}&filter=true&status=true&role=class-association`),
        dataService.GetAPI(`sections?branch_id=${id}&filter=true&status=true&role=class-association`),
        dataService.GetAPI(`users?institution_id=${res['custom:institution_id']}&user_type=staff-user&branch_id=${id}&sort=created_at%2Bdesc&filter=true&staff_type=Teaching&status=true&role=class-association`),
        dataService.GetAPI(`subjects?branch_id=${id}&filter=true&status=true&role=class-association`),
        dataService.GetAPI(`exams?branch_id=${id}&filter=true&status=true&role=class-association`)

    ]);
    
    return {
        classes:classList.data.data.data,
        sections:sectionList.data.data.data,
        academic_year:yearList.data.data.data,
        teachers:convertData(teachers.data.data.data),
        subjects:subjectList.data.data.data,
        exams:exams.data.data.data,

    }
};